import { connect } from 'react-redux';

const ToggleSelectAllAction = (item) => ({
  type: 'ToggleSelectAll',
  payload: item,
});

export const withToggleSelectAll = (WrappedComponent) => connect(null, { ToggleSelectAllAction })(WrappedComponent);
